import { useState, useEffect } from 'react';
import styles from './GoogleReviews.module.scss';
import { Rate } from 'antd';

const GoogleReviews = () => {
  const placeId = process.env.REACT_APP_GOOGLE_PLACE_ID;
  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  const [rating, setRating] = useState(null);
  const [ratingCount, setRatingCount] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Load Google Maps Places API script dynamically
    const loadGoogleMapsScript = () => {
      if (!window.google) {
        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
        script.async = true;
        script.defer = true;
        script.onload = () => fetchPlaceRating();
        script.onerror = () => setError('Failed to load Google Maps API');
        document.head.appendChild(script);
      } else {
        fetchPlaceRating();
      }
    };

    // Fetch place rating from Google Maps Places API
    const fetchPlaceRating = () => {
      if (!placeId || !apiKey) {
        setError('Place ID or API key is missing');
        setLoading(false);
        return;
      }

      try {
        const service = new window.google.maps.places.PlacesService(document.createElement('div'));
        service.getDetails({ placeId }, (place, status) => {
          if (status === window.google.maps.places.PlacesServiceStatus.OK && place.rating) {
            setRating(place.rating);
            setRatingCount(place.user_ratings_total);
            setLoading(false);
          } else {
            setError('Unable to fetch rating');
            setLoading(false);
          }
        });
      } catch (err) {
        setError('Error fetching place details');
        setLoading(false);
      }
    };

    loadGoogleMapsScript();
  }, [placeId, apiKey]);

  if (loading) return <div>Loading rating...</div>;
  if (error) return <div className="text-red-500">{error}</div>;

  return (
    <div className="d-flex flex-row items-center space-x-2 gap-2">
      <img
        className={styles.google_icon}
        src="/layout-icons/google-icon.webp"
        alt="Google Reviews"
      />
      <div className={styles.review_details}>
        <span className={styles.review_details_title}>Google Reviews</span>
        <div className='d-flex gap-2'>
          <span className={styles.review_details_description}>
            {rating ? rating.toFixed(1) : 'No rating'}
            ({ratingCount} Reviews)
          </span>
          <Rate allowHalf disabled value={rating} />
          <a className={styles.link} target='blank' href={`https://search.google.com/local/writereview?placeid=${placeId}`}>
            Rate us on Google!
          </a>
        </div>
      </div>
    </div>
  );
};

export default GoogleReviews;